module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "mdl-progress mdl-js-progress mdl-progress__indeterminate"
  }, [_vm._v("\n    Cargando...\n  ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7eeda317","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/Progress/index.vue
// module id = 241
// module chunks = 0